/**
 * Image conversion — Pillow on the API.
 * POST /api/image-convert
 */
import apiClient, { createAuthConfig } from "../client";
import { getExportErrorMessage } from "../editor/export";

/**
 * @param {string} token
 * @param {File} file
 * @param {{ sourceFormat: string, targetFormat: string }} options
 * @returns {Promise<Blob>}
 */
export async function convertImageFile(token, file, options) {
  const formData = new FormData();
  formData.append("file", file, file?.name || "upload");
  formData.append("source_format", options.sourceFormat);
  formData.append("target_format", options.targetFormat);

  const auth = createAuthConfig(token);
  const response = await apiClient.post("/api/image-convert", formData, {
    ...auth,
    responseType: "blob",
    timeout: 120000,
  });

  const blob = response.data;
  if (blob instanceof Blob && blob.type && blob.type.includes("json")) {
    const err = new Error("Conversion failed.");
    err.response = { data: blob };
    throw err;
  }
  return blob;
}

export { getExportErrorMessage };
